// extracted by mini-css-extract-plugin
module.exports = {"container":"WebViewVNP_container__E2ZXr","contend_view":"WebViewVNP_contend_view__3R1sH","logo_VNP":"WebViewVNP_logo_VNP__3pIzf"};